import { createSlice } from '@reduxjs/toolkit';

import { LoadProfile } from 'entities/LoadProfile';
import { AppError } from 'entities/Errors';

import { getLoadProfileList } from './load_profile.action';

interface LoadProfileState {
  loading: boolean;
  error: null | AppError;
  loadProfiles: LoadProfile[];
}

const initialState = {
  loading: false,
  error: null,
  loadProfiles: [],
} as LoadProfileState;

export const loadProfileSlice = createSlice({
  name: 'loadProfile',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getLoadProfileList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLoadProfileList.fulfilled, (state, action) => {
        state.loading = false;
        state.loadProfiles = action.payload.data;
      })
      .addCase(getLoadProfileList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default loadProfileSlice.reducer;
